import { render, staticRenderFns } from "./ErrataOverview.vue?vue&type=template&id=37e692d5&"
import script from "./ErrataOverview.vue?vue&type=script&lang=ts&"
export * from "./ErrataOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ErrataOverview.vue?vue&type=style&index=0&id=37e692d5&prod&module=true&lang=stylus&"
import style1 from "./ErrataOverview.vue?vue&type=style&index=1&id=37e692d5&prod&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports